/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  getTheme,
  mergeStyleSets,
  IButtonStyles,
  IStackStyles,
  IStackTokens,
  ITextStyles,
  FontWeights,
  ICommandBarStyles,
} from "@fluentui/react";

const theme = getTheme();

/**
 * The stack containing all of the form elements.
 */
export const containerStyles: IStackStyles = {
  root: {
    marginBottom: "0",
    padding: "0.5rem",
    backgroundColor: theme.palette.white,
    borderRadius: "8px",
    height: "100%",
  },
};

export const buttonStyles: IButtonStyles = {
  root: { marginRight: 8 },
};

export const deleteButtonStyles: IButtonStyles = {
  root: {
    marginRight: 8,
    border: `1px solid ${theme.palette.blue}`,
    color: theme.palette.blue,
  },
  rootHovered: {
    backgroundColor: theme.palette.white,
    color: theme.palette.blue,
  },
  rootPressed: {
    backgroundColor: theme.palette.blue,
    color: theme.palette.blue,
  },
};

export const panelHeaderStyles: ITextStyles = {
  root: {
    fontWeight: "600",
    fontSize: "32px",
    lineHeight: "40px",
    flexGrow: 1,
    margin: "24px",
  },
};

export const popupTitleStyles: ITextStyles = {
  root: {
    color: theme.palette.blue,
    fontWeight: "600",
    fontSize: "20px",
    lineHeight: "28px",
  },
};

export const popupContentStyles: ITextStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "22px",
  },
};

export const popupStyles = mergeStyleSets({
  root: {
    background: "rgba(0, 0, 0, 0.2)",
    bottom: "0",
    left: "0",
    position: "fixed",
    right: "0",
    top: "0",
  },
  content: {
    borderTopStyle: "solid",
    borderTopColor: theme.palette.blue,
    background: "white",
    left: "50%",
    maxWidth: "300px",
    padding: "0 1em 1em",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
});

export const popupHorizontalGapStackTokens: IStackTokens = {
  childrenGap: 10,
  padding: 10,
};

export const commandBarStyles: ICommandBarStyles = {
  root: {
    borderRadius: "8px",
    boxShadow: " 0px 1px 4px rgba(0, 0, 0, 0.2)",
    margin: "1rem 0.5rem 1.5rem",
    marginTop: "0",
    padding: "0.75rem",
    selectors: {
      ["button"]: {
        marginRight: "36px",
      },
      [".ms-Button-label"]: {
        fontSize: "14px",
        fontWeight: FontWeights.semibold,
      },
      ["i[data-icon-name='Blocked']"]: {
        color: theme.palette.red,
      },
    },
  },
};
